
const routes = [
  {
    path: '/welfare',
    name: 'Welfare',
    component: () => import(/* webpackChunkName: "about" */ '../views/welfare/welfarePc.vue'),
    meta: { title: '电商卖家限时福利！' },
  },
  {
    path: '/pullNew',
    name: 'pullNew',
    component: () => import(/* webpackChunkName: "about" */ '../views/pullNew/index-pc.vue'),
    meta: { title: '大客户拉新活动' },
  },
  {
    path: '/pullNew2',
    name: 'pullNew2',
    component: () => import(/* webpackChunkName: "about" */ '../views/pullNew2/index-pc.vue'),
    meta: { title: '大客户拉新活动' },
  },
  {
    path: '/JTPullNew',
    name: 'JTPullNew',
    component: () => import(/* webpackChunkName: "about" */ '../views/JTPullNew/index-pc.vue'),
    meta: { title: '大客户拉新活动' },
  },
  // {
  //   path: '*',
  //   redirect:{path:"/"}
  // }
]

export default routes
